import { render, staticRenderFns } from "./support-log.vue?vue&type=template&id=a004e4be&scoped=true&"
import script from "./support-log.vue?vue&type=script&lang=js&"
export * from "./support-log.vue?vue&type=script&lang=js&"
import style0 from "./support-log.vue?vue&type=style&index=0&id=a004e4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a004e4be",
  null
  
)

export default component.exports